import AddIcon from "@mui/icons-material/Add";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Divider, Grid, Typography } from "@mui/material";
import { groupBy, uniq } from "lodash";
import { useEffect, useState } from "react";
import SortableList, { SortableItem } from "react-easy-sort";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomSwitch from "../../../components/CustomSwitch";
import CustomTextField from "../../../components/CustomTextField";
import CustomSelect from "../../../components/Select/Select";
import {
  createDiagnosticTemplate,
  getDiagnosticTemplates,
  getVitalGroupsDetailsByIdWoLoader,
  getVitalGroupsWoLoader,
  getVitalsByIdsWoLoader,
  updateDiagnosticTemplateById,
} from "../../../redux/reducers/clinicSlice";
import { AppColors } from "../../../util/AppColors";
import { addIcon, delBtn } from "../../../util/CommonIconStyle";
import { answerTypes } from "../../../util/dropList";

const initObject = {
  question: "",
  questionType: "checkboxes",
  isRequired: false,
  questionId: null,
  answers: [""],
};
const initValue = { name: "" };

const DiagnosticTemplateCreate = ({
  setCreateVsble,
  selectedTemp,
  setSelectedTemp,
}) => {
  const dispatch = useDispatch();
  const [activeStep, setActiveStep] = useState(0);
  const [vitalModVsble, setVitalModVsble] = useState(false);
  const [vitalValues, setVitalValues] = useState({});
  const [tempValues, setTempValues] = useState(initValue);
  const [questions, setQuestions] = useState([]);
  const { vitalGroups, vitalListById, vitalsByIds } = useSelector(
    (state) => state.clinic,
  );

  useEffect(() => {
    dispatch(getVitalGroupsWoLoader());
  }, []);

  useEffect(() => {
    if (!selectedTemp) return;
    getAndSetDataFromSelectedPlan();
  }, [selectedTemp]);

  const getAndSetDataFromSelectedPlan = () => {
    const tempValObj = { ...tempValues, name: selectedTemp?.templateName };
    setTempValues(tempValObj);
    const vitalIds = selectedTemp?.question
      ?.filter((li) => li?.vitalId)
      ?.map((li) => li?.vitalId);
    if (vitalIds?.length > 0) {
      dispatch(getVitalsByIdsWoLoader(vitalIds)).then((res) => {
        if (res?.payload) {
          const vitalList = res?.payload ?? [];
          const reqList = selectedTemp?.question?.map((li, i) => {
            let reqObj = {
              question: li?.question,
              questionType: li?.questionType,
              questionId: li?.questionId,
              required: li?.required,
              isRequired: li?.required,
            };
            if (li?.vitalGroupId) reqObj.vitalGroupId = li?.vitalGroupId;
            if (li?.vitalId) {
              const matchObj = vitalList?.find(
                (vli) => vli?.vitalId === li?.vitalId,
              );
              if (matchObj) {
                reqObj = { ...(matchObj ?? {}), ...(reqObj ?? {}) };
                if (matchObj.groupName)
                  reqObj.vitalGroupName = matchObj.groupName;
              }
              reqObj.vitalId = li?.vitalId;
            }
            if (
              li?.questionType === "multipleChoice" ||
              li?.questionType === "checkboxes" ||
              li?.questionType === "fileupload"
            ) {
              reqObj.answers =
                li?.questionType === "fileupload" ? ["file"] : li?.answer;
            }
            if (
              li?.questionType === "shortAnswer" ||
              li?.questionType === "paragraph"
            ) {
              reqObj.answer = li?.answer ?? "";
            }
            return reqObj;
          });
          setQuestions(reqList);
        }
      });
      return;
    }
    const reqList = selectedTemp?.question?.map((li, i) => {
      const reqObj = {
        question: li?.question,
        questionType: li?.questionType,
        questionId: li?.questionId,
        required: li?.required,
        isRequired: li?.required,
      };
      if (li?.vitalGroupId) reqObj.vitalGroupId = li?.vitalGroupId;
      if (li?.vitalId) reqObj.vitalId = li?.vitalId;
      if (
        li?.questionType === "multipleChoice" ||
        li?.questionType === "checkboxes" ||
        li?.questionType === "fileupload"
      ) {
        reqObj.answers =
          li?.questionType === "fileupload" ? ["file"] : li?.answer;
      }
      if (
        li?.questionType === "shortAnswer" ||
        li?.questionType === "paragraph"
      ) {
        reqObj.answer = li?.answer ?? "";
      }
      return reqObj;
    });
    setQuestions(reqList);
  };

  const handleChange = (name, value) => {
    setTempValues({
      ...tempValues,
      [name]: value,
      error: value?.length > 0 ? false : true,
    });
  };

  const moveArrayElement = (array, fromIndex, toIndex) => {
    const updatedArray = [...array];
    const [movedItem] = updatedArray.splice(fromIndex, 1); // Remove the item from the old index
    updatedArray.splice(toIndex, 0, movedItem); // Insert it at the new index
    return updatedArray;
  };

  const onSortEnd = (oldIndex, newIndex) => {
    setQuestions((array) => moveArrayElement(array, oldIndex, newIndex));
  };

  const handleChangeValue = (name, value, ind) => {
    const vitalList = questions?.filter((li) => li?.vitalId);
    const reqList = questions
      ?.filter((li) => !li?.isDelete && !li?.vitalId)
      ?.map((li, i) => {
        if (i === ind) {
          const reqObj = { ...li, [name]: value };
          if (
            value === "multipleChoice" ||
            value === "checkboxes" ||
            value === "fileupload"
          ) {
            reqObj.answers = [value === "fileupload" ? "file" : ""];
          }
          if (value === "shortAnswer" || value === "paragraph") {
            reqObj.answer = "";
          }
          return reqObj;
        }
        return li;
      });
    setQuestions([...(vitalList ?? []), ...(reqList ?? [])]);
  };

  const handleChangeAnswer = (mainInd, secInd, value) => {
    const vitalList = questions?.filter((li) => li?.vitalId);
    const reqList = questions
      ?.filter((li) => !li?.isDelete && !li?.vitalId)
      ?.map((li, i) => {
        if (i === mainInd) {
          const reqArr = li?.answers?.map((ans, ind) => {
            if (ind === secInd) return value;
            return ans;
          });
          return { ...li, answers: reqArr };
        }
        return li;
      });
    setQuestions([...(vitalList ?? []), ...(reqList ?? [])]);
  };

  const handleAddQuestion = () => {
    setQuestions((prev) => [...prev, initObject]);
  };

  const handleDeleteQuestion = (ind) => {
    const vitalList = questions?.filter((li) => li?.vitalId);
    const reqQues = questions
      ?.filter((li) => !li?.isDelete && !li?.vitalId)
      ?.reduce((acc, item, i) => {
        if (i === ind) {
          if (item?.questionId) acc.push({ ...item, isDelete: true });
        } else {
          acc.push(item);
        }
        return acc;
      }, [])
      ?.map((cl, i) => ({ ...cl, i }));
    setQuestions([...(vitalList ?? []), ...(reqQues ?? [])]);
  };

  const handleBackClick = () => {
    dispatch(getDiagnosticTemplates());
    setTempValues(initValue);
    setCreateVsble(false);
    setSelectedTemp(null);
    setActiveStep(0);
  };

  const handleAddAnswer = (ind) => {
    const vitalList = questions?.filter((li) => li?.vitalId);
    const reqList = questions
      ?.filter((li) => !li?.isDelete && !li?.vitalId)
      ?.map((li, i) => {
        if (i === ind) {
          return { ...li, answers: [...li?.answers, ""] };
        }
        return li;
      });
    setQuestions([...(vitalList ?? []), ...(reqList ?? [])]);
  };

  const handleDeleteAnswer = (mainInd, secInd) => {
    const vitalList = questions?.filter((li) => li?.vitalId);
    const reqList = questions
      ?.filter((li) => !li?.isDelete && !li?.vitalId)
      ?.map((li, i) => {
        if (i === mainInd) {
          const reqArr = li?.answers?.filter((ans, ind) => ind !== secInd);
          return { ...li, answers: reqArr };
        }
        return li;
      });
    setQuestions([...(vitalList ?? []), ...(reqList ?? [])]);
  };

  const handleNext = () => {
    if (tempValues?.name?.length === 0 || !tempValues?.name) {
      return setTempValues({ ...tempValues, error: true });
    }
    if (
      questions?.length === 0 ||
      questions?.some((li) => li?.question?.length === 0 || !li?.questionType)
    )
      return;
    setActiveStep(activeStep + 1);
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  const handleSubmit = () => {
    const question = questions?.map((ques) => {
      const reqObj = {
        question: ques?.question,
        questionType: ques?.questionType,
        required: ques?.isRequired,
        isDelete: ques?.isDelete ?? false,
      };
      if (
        ques?.questionType === "shortAnswer" ||
        ques?.questionType === "paragraph"
      ) {
        reqObj.answer = [ques?.answer];
      }
      if (
        ques?.questionType === "multipleChoice" ||
        ques?.questionType === "checkboxes"
      ) {
        reqObj.answer = ques?.answers;
      }
      if (ques?.questionType === "fileupload") {
        reqObj.answer = ques?.answers;
      }
      if (ques?.questionId) reqObj.questionId = ques?.questionId;
      if (ques?.vitalGroupId || ques?.vitalId) {
        reqObj.vitalGroupId = ques?.vitalGroupId;
        reqObj.vitalId = ques?.vitalId;
      }
      return reqObj;
    });
    const data = { templateName: tempValues?.name, question };

    if (selectedTemp) {
      dispatch(
        updateDiagnosticTemplateById({
          tempId: selectedTemp?.templateId,
          data,
        }),
      ).then((res) => {
        if (res?.payload) handleBackClick();
      });
    } else {
      dispatch(createDiagnosticTemplate(data)).then((res) => {
        if (res?.payload) handleBackClick();
      });
    }
  };

  const handleAddVital = () => {
    setVitalValues({ group: null });
    setVitalModVsble(true);
  };

  const onCloseVitalMod = () => {
    setVitalModVsble(false);
    setVitalValues({});
  };

  const getVitalGroups = () => {
    return vitalGroups?.map((item) => ({
      name: item?.groupName,
      value: item?.groupName,
      vitalGroupId: item?.roomId,
    }));
  };

  const onChange = (name, value) => {
    if (name === "group") {
      if (value?.vitalGroupId) {
        dispatch(getVitalGroupsDetailsByIdWoLoader(value?.vitalGroupId));
      }
    }
    setVitalValues({
      ...vitalValues,
      [name]: value,
      error: value?.vitalGroupId ? false : true,
    });
  };

  const handleAddVitalGroup = () => {
    const vitalQuestions = (vitalListById ?? [])?.map((vl) => {
      const reqObj = {
        ...vl,
        question: vl?.vitalName,
        questionType:
          vl?.inputType === "TextBox" ? "shortAnswer" : "multipleChoice",
        isRequired: false,
        questionId: null,
        answers: [""],
        vitalId: vl?.vitalId,
        vitalGroupId: vitalValues?.group?.vitalGroupId,
        vitalGroupName: vl?.groupName,
        inputType: vl?.inputType,
      };
      return reqObj;
    });
    const reqList = [...(vitalQuestions ?? []), ...(questions ?? [])];
    setQuestions(reqList);
    setVitalModVsble(false);
    setVitalValues({});
  };

  const getUniqVitalGroupIds = () => {
    const reqList =
      questions
        ?.filter((li) => li?.vitalGroupId)
        ?.map((li) => li?.vitalGroupId) ?? [];
    return uniq(reqList);
  };

  const getGroupByVitals = () => {
    const reqQuestions =
      questions?.filter((li) => li?.vitalId || li?.vitalGroupId) ?? [];
    const reqGroupBy = groupBy(reqQuestions, "vitalGroupId");
    return reqGroupBy;
  };

  const handleDeleteVitalGroup = (id) => {
    const reqList = questions?.filter((li) => li?.vitalGroupId !== id);
    setQuestions(reqList);
  };

  return (
    <>
      <div className="ml50 cursor mt10" onClick={handleBackClick}>
        <div className="flex-row-ali-cen">
          <ArrowBackIosIcon
            sx={{ color: AppColors.appPrimary, width: 20, height: 20 }}
          />
          <Typography className="fs16 txt-semi-bold blue-color ml5">
            Back
          </Typography>
        </div>
      </div>
      <Grid container spacing={0} className="flex-center mt20">
        <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
          <div className="scroll-70vh pr10 pb30">
            {activeStep === 0 ? (
              <div>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <div className="txt-semi-bold fs14 blue-color">
                      Template Name <span className="red-color">*</span>
                    </div>
                    <CustomTextField
                      value={tempValues?.name}
                      handleChange={(e) =>
                        handleChange("name", e?.target?.value)
                      }
                      fullWidth
                      error={tempValues?.error}
                      helperText={
                        tempValues?.error ? "This field is required" : ""
                      }
                    />
                  </Grid>
                </Grid>
                {getUniqVitalGroupIds()?.length > 0 ? (
                  <div>
                    {getUniqVitalGroupIds()?.map((grp, i) => (
                      <div key={`${grp}_${i}`} className="mt15">
                        <div className="flex-row-ali-cen">
                          <div className="blue-color fs16 txt-semi-bold">
                            {getGroupByVitals()?.[grp]?.[0]?.vitalGroupName}
                          </div>
                          <div
                            className="cursor ml15"
                            onClick={() =>
                              handleDeleteVitalGroup(
                                getGroupByVitals()?.[grp]?.[0]?.vitalGroupId,
                              )
                            }
                          >
                            <div className="flex-center">
                              <DeleteOutlineIcon sx={delBtn} />
                            </div>
                            <Typography className="red3 fs8 txt-semi-bold text-align-center">
                              Delete
                            </Typography>
                          </div>
                        </div>
                        <div className="flex-row-ali-cen ph20 mt10">
                          <div className="w30Per">
                            <Typography className="font-bold blue-color fs12">
                              Vital Name
                            </Typography>
                          </div>
                          <div className="w20Per">
                            <Typography className="font-bold blue-color fs12">
                              Reference Range
                            </Typography>
                          </div>
                          <div className="w20Per">
                            <Typography className="font-bold blue-color fs12">
                              Input Type
                            </Typography>
                          </div>
                        </div>
                        <div className="blue-hor-split mt5" />
                        {getGroupByVitals()?.[grp]?.map((vqu, ind) => {
                          // const reqVit = vitalListById?.find(
                          //   (vli) => vli?.vitalId === vqu?.vitalId,
                          // );

                          return (
                            <div
                              className="flex-row-ali-cen mt5 ph20"
                              key={`${vqu?.vitalId}_${ind}`}
                            >
                              <div className="w30Per txt-semi-bold fs12 black">
                                {vqu?.question}
                                {vqu?.unit?.length > 0 ? ` ${vqu?.unit}` : ""}
                              </div>
                              <div className="w20Per font-medium fs12 gray3">
                                {vqu?.unit?.length > 0 &&
                                  `${vqu?.lowerRange ?? ""} - ${vqu?.upperRange ?? ""}`}
                              </div>
                              <div className="w20Per font-medium fs12 gray3">
                                {vqu?.inputType}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ))}
                  </div>
                ) : null}
                <SortableList
                  onSortEnd={onSortEnd}
                  className="parent-list"
                  dragHandleSelector=".parent-drag-handle"
                  tag="div"
                >
                  {questions
                    ?.filter((li) => !li?.isDelete && !li?.vitalId)
                    ?.map((ques, i) => {
                      return (
                        <SortableItem key={`${i}-parent`}>
                          <Grid container spacing={1} className="mt10">
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                              <Typography className="fs16 blue-color font-medium">
                                Title Name {i + 1}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                              <CustomTextField
                                fullWidth
                                handleChange={(e) =>
                                  handleChangeValue(
                                    "question",
                                    e?.target?.value,
                                    i,
                                  )
                                }
                                value={ques?.question}
                                placeholder="Type title here"
                                disabled={ques?.vitalGroupId && ques?.vitalId}
                              />
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                              <CustomSelect
                                list={answerTypes}
                                value={ques?.questionType}
                                handleChange={(e) =>
                                  handleChangeValue(
                                    "questionType",
                                    e?.target?.value,
                                    i,
                                  )
                                }
                                select
                                disabled={ques?.vitalGroupId && ques?.vitalId}
                              />
                            </Grid>
                            {ques?.questionType === "multipleChoice" ||
                            ques?.questionType === "checkboxes" ? (
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                xl={12}
                              >
                                {ques?.answers?.map((ans, ind) => (
                                  <div className="flex-row-ali-cen">
                                    <div className="ml10">
                                      <CustomCheckbox
                                        value={false}
                                        circle={
                                          ques?.questionType ===
                                          "multipleChoice"
                                        }
                                        disabled={
                                          ques?.vitalGroupId && ques?.vitalId
                                        }
                                      />
                                    </div>
                                    <div className="w60Per">
                                      <CustomTextField
                                        value={ans}
                                        fullWidth
                                        handleChange={(e) =>
                                          handleChangeAnswer(
                                            i,
                                            ind,
                                            e?.target?.value,
                                          )
                                        }
                                        disabled={
                                          ques?.vitalGroupId && ques?.vitalId
                                        }
                                      />
                                    </div>
                                    {ques?.answers?.length === ind + 1 &&
                                    !(ques?.vitalGroupId && ques?.vitalId) ? (
                                      <img
                                        src={require("../../../assets/images/png/plusGry.png")}
                                        className="img-wh20 ml10 cursor"
                                        onClick={() => handleAddAnswer(i)}
                                      />
                                    ) : null}
                                    {ques?.answers?.length > 1 &&
                                    !(ques?.vitalGroupId && ques?.vitalId) ? (
                                      <img
                                        src={require("../../../assets/images/png/delGry.png")}
                                        className="img-wh20 ml10 cursor"
                                        onClick={() =>
                                          handleDeleteAnswer(i, ind)
                                        }
                                      />
                                    ) : null}
                                  </div>
                                ))}
                              </Grid>
                            ) : ques?.questionType === "paragraph" ||
                              ques?.questionType === "shortAnswer" ? (
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                xl={12}
                              >
                                <CustomTextField
                                  value={ques?.answer}
                                  fullWidth
                                  handleChange={(e) =>
                                    handleChangeValue(
                                      "answer",
                                      e?.target?.value,
                                      i,
                                    )
                                  }
                                  disabled={ques?.vitalGroupId && ques?.vitalId}
                                  multiline={ques?.questionType === "paragraph"}
                                />
                              </Grid>
                            ) : null}
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                              <div className="flex-row-between-align-center mt10">
                                <div className="flex-row-ali-cen">
                                  <div className="cursor">
                                    <span className="parent-drag-handle">
                                      ☰
                                    </span>
                                  </div>
                                  <img
                                    src={require("../../../assets/images/png/del.png")}
                                    className="img-wh20 cursor ml10"
                                    onClick={() => handleDeleteQuestion(i)}
                                  />
                                </div>
                                <div className="pr10 flex-center">
                                  <CustomSwitch
                                    value={ques?.isRequired}
                                    onChange={(e) =>
                                      handleChangeValue(
                                        "isRequired",
                                        e?.target?.value,
                                        i,
                                      )
                                    }
                                    grayToBlue
                                    disabled={
                                      ques?.vitalGroupId && ques?.vitalId
                                    }
                                  />
                                </div>
                              </div>
                            </Grid>
                          </Grid>
                        </SortableItem>
                      );
                    })}
                </SortableList>
                <div className="flex-row-ali-cen mt20">
                  <div
                    className="flex-row-ali-cen cursor"
                    onClick={handleAddQuestion}
                  >
                    <div className="flex-center plus-icon">
                      <AddIcon sx={addIcon} />
                    </div>
                    <Typography className="blue-color fs16 ml5 font-bold">
                      Add Field
                    </Typography>
                  </div>

                  <div
                    className="flex-row-ali-cen cursor ml15"
                    onClick={handleAddVital}
                  >
                    <div className="flex-center plus-icon">
                      <AddIcon sx={addIcon} />
                    </div>
                    <Typography className="blue-color fs16 ml5 font-bold">
                      Add Vital
                    </Typography>
                  </div>
                </div>

                <div className="flex-end mt20">
                  <div>
                    <CustomButton text="Next" smallBtn onClick={handleNext} />
                  </div>
                </div>
              </div>
            ) : null}
            {activeStep === 1 ? (
              <div>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Typography className="blue-color txt-semi-bold flex-center fs20">
                      Review & Submit
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <div className="txt-semi-bold fs14 blue-color">
                      Template Name
                    </div>
                    <CustomTextField
                      value={tempValues?.name}
                      fullWidth
                      disabled
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    {getUniqVitalGroupIds()?.length > 0 ? (
                      <div>
                        {getUniqVitalGroupIds()?.map((grp, i) => (
                          <div key={`${grp}_${i}`} className="mt15">
                            <div className="flex-row-ali-cen">
                              <div className="blue-color fs16 txt-semi-bold">
                                {getGroupByVitals()?.[grp]?.[0]?.vitalGroupName}
                              </div>
                            </div>
                            <div className="flex-row-ali-cen ph20 mt10">
                              <div className="w30Per">
                                <Typography className="font-bold blue-color fs12">
                                  Vital Name
                                </Typography>
                              </div>
                              <div className="w20Per">
                                <Typography className="font-bold blue-color fs12">
                                  Reference Range
                                </Typography>
                              </div>
                              <div className="w20Per">
                                <Typography className="font-bold blue-color fs12">
                                  Input Type
                                </Typography>
                              </div>
                            </div>
                            <div className="blue-hor-split mt5" />
                            {getGroupByVitals()?.[grp]?.map((vqu, ind) => {
                              // const reqVit = vitalListById?.find(
                              //   (vli) => vli?.vitalId === vqu?.vitalId,
                              // );

                              return (
                                <div
                                  className="flex-row-ali-cen mt5 ph20"
                                  key={`${vqu?.vitalId}_${ind}`}
                                >
                                  <div className="w30Per txt-semi-bold fs12 black">
                                    {vqu?.question}
                                    {vqu?.unit?.length > 0
                                      ? ` ${vqu?.unit}`
                                      : ""}
                                  </div>
                                  <div className="w20Per font-medium fs12 gray3">
                                    {vqu?.unit?.length > 0 &&
                                      `${vqu?.lowerRange ?? ""} - ${vqu?.upperRange ?? ""}`}
                                  </div>
                                  <div className="w20Per font-medium fs12 gray3">
                                    {vqu?.inputType}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        ))}
                      </div>
                    ) : null}
                    {questions
                      ?.filter((li) => !li?.isDelete && !li?.vitalId)
                      ?.map((ques, i) => (
                        <div key={`${ques?.question} ${i}`} className="mv5">
                          <Typography className="font-medium fs16 black">
                            {/* {i + 1})  */}
                            {ques?.question}
                          </Typography>
                          <div className="mv5">
                            {ques?.questionType === "multipleChoice" ||
                            ques?.questionType === "checkboxes" ? (
                              <div className="ml10">
                                {ques?.answers?.map((ans) => (
                                  <div className="flex-row-ali-cen">
                                    <CustomCheckbox
                                      value={false}
                                      circle={
                                        ques?.questionType === "multipleChoice"
                                      }
                                      disabled
                                    />
                                    <Typography className="mlMin15 font-medium fs14 black">
                                      {ans}
                                    </Typography>
                                  </div>
                                ))}
                              </div>
                            ) : ques?.questionType === "paragraph" ||
                              ques?.questionType === "shortAnswer" ? (
                              <Typography className="font-medium fs14 black">
                                {ques?.answer}
                              </Typography>
                            ) : null}
                          </div>
                        </div>
                      ))}
                  </Grid>
                </Grid>
                <div className="flex-end">
                  <div>
                    <CustomButton
                      text="Back"
                      smallBtn
                      grayBtn
                      onClick={handleBack}
                    />
                  </div>

                  <div className="ml20">
                    <CustomButton
                      text="Submit"
                      smallBtn
                      onClick={handleSubmit}
                    />
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </Grid>
      </Grid>

      <CustomModal
        open={vitalModVsble}
        onClose={onCloseVitalMod}
        header="Add Vital"
        rightModal
        modalWidth={30}
      >
        <div className="ph20 scroll-80vh">
          <Typography className="blue-color fs14 txt-semi-bold">
            Vital Group
          </Typography>
          <div className="mt10">
            <CustomSelect
              list={getVitalGroups()}
              value={vitalValues?.group}
              handleChange={(e, value) => onChange("group", value)}
              search
              error={vitalValues?.error}
              helperText={vitalValues?.error ? "This field is required" : ""}
            />
          </div>
          <div className="mt10">
            {vitalValues?.group?.vitalGroupId && vitalListById?.length > 0 ? (
              <>
                <Typography className="blue-color fs14 txt-semi-bold">
                  Vital Group Name: {vitalListById?.[0]?.groupName}
                </Typography>
                {vitalListById?.map((li) => (
                  <div key={li?.vitalId} className="mt5">
                    <Typography className="txt-semi-bold fs14 black">
                      {li?.vitalName}
                    </Typography>
                    <Typography className="font-medium fs12 gray4">
                      {li?.inputType}
                    </Typography>
                    <Divider />
                  </div>
                ))}
              </>
            ) : null}
          </div>
          {vitalValues?.group?.vitalGroupId ? (
            <div className="flex1-end mv20">
              <div>
                <CustomButton
                  smallBtn
                  text="Add"
                  onClick={handleAddVitalGroup}
                />
              </div>
            </div>
          ) : null}
        </div>
      </CustomModal>
    </>
  );
};

export default DiagnosticTemplateCreate;
